import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as Bearer for cross-domain reliability
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ean_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Send the user-visible origin so backend can use it for redirects (MP back_url)
  // — the underlying Origin header may be stripped by ingress/CDN.
  if (typeof window !== "undefined" && window.location) {
    config.headers = config.headers || {};
    config.headers["X-Frontend-Origin"] = window.location.origin;
    // Impersonation header — only super-admins can set this via /admin/users panel
    const impersonate = localStorage.getItem("impersonate_user_id");
    if (impersonate) {
      config.headers["X-Impersonate-User-Id"] = impersonate;
    }
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
